module.exports = __webpack_public_path__ + "static/media/b14-全华水彩艺术馆.36d702da.png";